import useTournamentStatusColor from '@/hooks/useTournamentStatusColor';
import { TournamentStatus as TournamentStatusEnum } from '@repo/common-types';
import { Badge } from 'reactstrap';

const TournamentStatus = ({
  status,
  deletedAt,
}: {
  status: TournamentStatusEnum;
  deletedAt?: Date | null | undefined;
}) => {
  const statusColor = useTournamentStatusColor(status);

  return (
    <div className="d-flex flex-column align-items-start justify-content-center gap-2">
      <Badge color={statusColor}>{status}</Badge>
      {deletedAt && <Badge color="danger">ARCHIVED</Badge>}
    </div>
  );
};

export default TournamentStatus;
